// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"ad4cf8ec","484":"77f0df29","500":"b9af12e8","551":"b07edcaf"}[chunkId] + ".chunk.js";
};